import clsx from "classnames";
import { NotificationItem } from "../NotificationItem";
import { useStyles } from "./InAppNotification.style";
import { FC, HTMLAttributes, useEffect } from "react";
import { useAppDispatch, useAppSelector } from "../../hooks";
import {
  closeNotification,
  hideNotification,
  setNotification,
} from "../../../store/slices/inAppNotification";

export const InAppNotification: FC<HTMLAttributes<HTMLDivElement>> = () => {
  const classes = useStyles();
  const dispatch = useAppDispatch();
  const { data, notiState, queue } = useAppSelector(
    (state) => state.inAppNotification,
  );

  useEffect(() => {
    if (!data) return;

    if (data.createdAt) {
      localStorage.setItem("recentNotificationTime", data.createdAt);
    }

    const timer = setTimeout(() => {
      dispatch(hideNotification());
    }, 5000);
    return () => clearTimeout(timer);
  }, [data, dispatch]);

  useEffect(() => {
    let timer: NodeJS.Timeout;

    if (notiState === "fadeOut") {
      timer = setTimeout(() => {
        if (queue.length > 0) {
          dispatch(setNotification({ data: queue[0] }));
        } else dispatch(closeNotification());
      }, 300);
    }
    return () => clearTimeout(timer);
  }, [notiState, queue, dispatch]);

  if (!data) return;

  return (
    <div
      className={clsx(
        classes.root,
        notiState === "show" && classes.forwardsAnimate,
        notiState === "fadeOut" && classes.backwardsAnimate,
      )}
      onTouchMove={() => dispatch(hideNotification())}
    >
      <NotificationItem isInApp notification={data} className={classes.noti} />
    </div>
  );
};
